import { useEffect, useState } from 'react';

type LeafletModule = typeof import('leaflet');
type ReactLeafletModule = typeof import('react-leaflet');

interface LeafletBundle {
  L: LeafletModule;
  components: {
    MapContainer: ReactLeafletModule['MapContainer'];
    TileLayer: ReactLeafletModule['TileLayer'];
    Marker: ReactLeafletModule['Marker'];
    Popup: ReactLeafletModule['Popup'];
    useMapEvents: ReactLeafletModule['useMapEvents'];
  };
}

export function useLeaflet() {
  const [bundle, setBundle] = useState<LeafletBundle | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const [leafletMod, reactLeaflet] = await Promise.all([
        import('leaflet'),
        import('react-leaflet'),
        import('leaflet/dist/leaflet.css'),
      ]);

      if (cancelled) return;
      const L = (leafletMod as any).default ?? leafletMod;
      setBundle({
        L,
        components: {
          MapContainer: reactLeaflet.MapContainer,
          TileLayer: reactLeaflet.TileLayer,
          Marker: reactLeaflet.Marker,
          Popup: reactLeaflet.Popup,
          useMapEvents: reactLeaflet.useMapEvents,
        },
      });
    })().catch((err) => {
      if (!cancelled) {
        console.warn('Leaflet load failed', err);
      }
    });

    return () => {
      cancelled = true;
    };
  }, []);

  return bundle;
}
